import {
	currentTargetRequired,
	getAttributeOrThrow,
	qsaRequired,
	qsOptional,
} from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { ProductSlider } from '@/scripts/theme/product-slider'

export class MultiProductSlider extends UcoastEl {
	static htmlSelector = 'multi-product-slider'
	navButtons: NodeListOf<HTMLButtonElement>
	sliderWrappers: NodeListOf<HTMLElement>
	sliders: NodeListOf<ProductSlider>
	navWrapper?: HTMLElement
	nav?: HTMLElement
	constructor() {
		super()
		this.navButtons = qsaRequired('button[data-nav]', this)
		this.sliderWrappers = qsaRequired('[data-slider]', this)
		this.sliders = qsaRequired(ProductSlider.htmlSelector, this)
		this.navWrapper = qsOptional('.multi-product-slider__nav-wrapper', this)
		this.nav = qsOptional('.multi-product-slider__nav', this)
		this.addListeners()
	}

	addListeners() {
		this.navButtons.forEach((button) => {
			button.addEventListener('click', this.activateSlider.bind(this))
		})
	}

	activateSlider(event: Event) {
		const currentTarget = currentTargetRequired(event)
		this.scrollNavToButton(currentTarget)
		const blockId = getAttributeOrThrow('data-nav', currentTarget)
		this.navButtons.forEach((navButton) => {
			const navBlockId = getAttributeOrThrow('data-nav', navButton)
			if (blockId === navBlockId) {
				navButton.classList.add('active')
			} else {
				navButton.classList.remove('active')
			}
		})
		this.sliderWrappers.forEach((sliderWrapper) => {
			const sliderBlockId = getAttributeOrThrow(
				'data-slider',
				sliderWrapper
			)
			if (blockId === sliderBlockId) {
				sliderWrapper.classList.add('active')
			} else {
				sliderWrapper.classList.remove('active')
			}
		})
	}

	// Scroll the overflow nav so the clicked category sits at the left edge,
	// preserving the nav's left gutter — hints there are more categories to scroll.
	scrollNavToButton(button: HTMLElement) {
		const wrapper = this.navWrapper
		if (!wrapper) return
		const padLeft = this.nav
			? parseFloat(getComputedStyle(this.nav).paddingLeft) || 0
			: 0
		const delta =
			button.getBoundingClientRect().left -
			wrapper.getBoundingClientRect().left -
			padLeft
		wrapper.scrollTo({ left: wrapper.scrollLeft + delta, behavior: 'smooth' })
	}
}
